/* Chill PDP chip nav.
   1. Lifts the spec accordions and PDF links out of the description into
      their own cards. Those nodes are injected client-side after load, so
      the split retries under a MutationObserver rather than assuming they
      are present at DOM ready.
   2. Extends the chip row with every content section that exists on the
      page, and owns scrolling for all chips via a capture-phase handler
      (the page swallows animated scrolls, so it jumps directly). */
(function () {
  var HEADER_OFFSET = 96;
  var root = null;
  var io = null;
  var tracked = [];

  function jumpTo(target) {
    var html = document.documentElement;
    var prev = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, target);
    html.style.scrollBehavior = prev;
  }

  function scrollToEl(el) {
    if (!el) return;
    var target = Math.max(0, el.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET);
    var start = window.pageYOffset;
    if (Math.abs(target - start) < 2) return;

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      jumpTo(target);
      return;
    }

    try {
      window.scrollTo({ top: target, behavior: 'smooth' });
    } catch (e) {
      jumpTo(target);
      return;
    }

    /* Smooth scrolling is frame-driven, so it never starts in a background
       tab or where the animation is unsupported. If nothing has moved
       shortly after, land on the target directly. */
    setTimeout(function () {
      if (Math.abs(window.pageYOffset - start) < 2) jumpTo(target);
    }, 250);
  }

  function observe(chip, target) {
    tracked.push({ chip: chip, target: target });
    if (io) io.observe(target);
  }

  function addChip(id, label, beforeSel) {
    if (!root || root.querySelector('a[href="#' + id + '"]')) return;
    var el = document.getElementById(id);
    if (!el) return;
    var a = document.createElement('a');
    a.className = 'cv-pdp-chip';
    a.href = '#' + id;
    a.textContent = label;
    a.setAttribute('data-cv-chip-extra', '');
    var before = beforeSel ? root.querySelector(beforeSel) : null;
    if (before) root.insertBefore(a, before); else root.appendChild(a);
    observe(a, el);
  }

  function makeCard(id, title, nodes) {
    if (!nodes.length) return null;
    var el = document.createElement('section');
    el.id = id;
    el.className = 'cv-pdp-card';
    var h = document.createElement('h2');
    h.className = 'cv-pdp-card-title';
    h.textContent = title;
    el.appendChild(h);
    var body = document.createElement('div');
    body.className = 'cv-pdp-card-body';
    nodes.forEach(function (n) { body.appendChild(n); });
    el.appendChild(body);
    return el;
  }

  function refreshClamp() {
    var clamp = document.querySelector('[data-cv-clamp]');
    var more = document.querySelector('[data-cv-more]');
    if (!clamp || !more || clamp.classList.contains('is-open')) return;
    if (clamp.scrollHeight <= clamp.clientHeight + 8) {
      more.style.display = 'none';
      clamp.classList.add('is-open');
    } else {
      more.style.display = '';
    }
  }

  function splitDescription() {
    var desc = document.querySelector('[data-cv-clamp] .prose');
    var descCard = document.querySelector('[data-product-description]');
    if (!desc || !descCard) return false;

    var specs = makeCard('cvsec-specs', 'Specifications', [].slice.call(desc.querySelectorAll('.cv-specs-acc')));
    var docs = makeCard('cvsec-docs', 'Documents', [].slice.call(desc.querySelectorAll('.cv-doclinks')));
    if (!specs && !docs) return false;

    var after = document.getElementById('cvsec-included') || descCard;
    [specs, docs].forEach(function (c) {
      if (!c) return;
      after.parentNode.insertBefore(c, after.nextSibling);
      after = c;
    });

    [].slice.call(desc.children).forEach(function (n) {
      if (!n.textContent.trim() && !n.querySelector('img, table, a')) n.remove();
    });

    addChip('cvsec-specs', 'Specifications', 'a[href$="__purchase_support"], a[href$="__reviews"], a[href$="__install_videos"]');
    addChip('cvsec-docs', 'Documents', 'a[href$="__purchase_support"], a[href$="__reviews"], a[href$="__install_videos"]');
    refreshClamp();
    return true;
  }

  function watchDescription() {
    var desc = document.querySelector('[data-cv-clamp] .prose');
    if (!desc || splitDescription()) return;
    var mo = new MutationObserver(function () {
      if (splitDescription()) mo.disconnect();
    });
    mo.observe(desc, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 10000);
  }

  /* Judge.me's preview badge renders as stars + "7 reviews" under the
     title. Rebuild it as "4.57 [stars] (7)" and put it in the SKU row in
     place of the stock pill. Judge.me reveals the badge after its own
     init, so this polls briefly rather than running once. */
  function moveRatingToMeta() {
    var badge = document.querySelector('.jdgm-prev-badge');
    var stock = document.querySelector('.cv-stock-badge');
    if (!badge || !stock) return false;
    var stars = badge.querySelector('.jdgm-prev-badge__stars');
    var count = parseInt(badge.getAttribute('data-number-of-reviews'), 10) || 0;
    var avg = parseFloat(badge.getAttribute('data-average-rating'));
    if (!stars || !count || isNaN(avg)) return false;

    var wrap = document.createElement('a');
    wrap.className = 'cv-rating-inline';
    wrap.href = '#';
    wrap.setAttribute('aria-label', avg.toFixed(2) + ' out of 5 from ' + count + ' reviews');

    var num = document.createElement('span');
    num.className = 'cv-rating-num';
    num.textContent = avg.toFixed(2);

    var copy = stars.cloneNode(true);
    copy.removeAttribute('role');
    copy.removeAttribute('tabindex');
    copy.removeAttribute('aria-label');

    var cnt = document.createElement('span');
    cnt.className = 'cv-rating-count';
    cnt.textContent = '(' + count + ')';

    wrap.appendChild(num);
    wrap.appendChild(copy);
    wrap.appendChild(cnt);
    wrap.addEventListener('click', function (e) {
      e.preventDefault();
      scrollToEl(document.querySelector('[id$="__reviews"]'));
    });

    stock.parentNode.replaceChild(wrap, stock);
    /* Judge.me re-shows its badge after its own init, so hide the original
       row with a class the stylesheet can outrank an inline style with. */
    var block = badge.closest('.jdgm-preview-badge') || badge.parentElement;
    if (block) block.classList.add('cv-rating-moved');
    return true;
  }

  function watchRating() {
    if (moveRatingToMeta()) return;
    var tries = 0;
    var timer = setInterval(function () {
      if (moveRatingToMeta() || ++tries > 40) clearInterval(timer);
    }, 300);
  }

  /* Coverage selector.
     Without a labor map: the original behavior - protection radios become
     three pills (No plan / 2-Year / 5-Year), label clicks drive the radios
     and theme.js's own click/toggle logic still applies.
     With [data-labor-variant-map] present (labor product set AND live):
     four button-pills (2-Year, 2-Year + Labor, 5-Year, 5-Year + Labor) plus
     a "skip coverage" text link. Buttons set the underlying protection
     radio programmatically (checked + change event, never a native click,
     so theme.js's same-term toggle-off cannot misfire) and labor selection
     is tracked here. The labor line item is merged into theme.js's own
     /cart/add.js request by a narrowly-guarded fetch wrapper below; on any
     anomaly the request passes through untouched. */
  var TIER_LABELS = ['$0-$249','$250-$499','$500-$999','$1,000-$1,499','$1,500-$2,499','$2,500-$3,499','$3,500-$4,999','$5,000-$6,999','$7,000-$9,999','$10,000-$14,999','$15,000+'];
  var laborState = { on: false, term: '', variantId: 0, tier: '', qtyForm: null };

  function laborTermFromVariant(v) {
    var t = ((v && v.option1 ? v.option1 : '') + ' ' + (v && v.title ? v.title : '')).toLowerCase();
    if (t.indexOf('5-year') !== -1 || t.indexOf('5 year') !== -1) return '5-year';
    if (t.indexOf('2-year') !== -1 || t.indexOf('2 year') !== -1) return '2-year';
    return '';
  }
  function laborTierFromVariant(v) {
    var t = (v && v.option2 ? v.option2 : '') + ' ' + (v && v.title ? v.title : '');
    for (var i = 0; i < TIER_LABELS.length; i++) { if (t.indexOf(TIER_LABELS[i]) !== -1) return TIER_LABELS[i]; }
    return '';
  }
  function readLaborMap(section) {
    var el = section.querySelector('[data-labor-variant-map]');
    if (!el) return null;
    var raw = [];
    try { raw = JSON.parse(el.textContent || '[]'); } catch (e) { return null; }
    var list = raw.map(function (v) {
      return { id: Number(v.id), term: laborTermFromVariant(v), tier: laborTierFromVariant(v), price: Number(v.price) || 0, available: v.available !== false };
    }).filter(function (v) { return isFinite(v.id) && v.id > 0 && v.term && v.tier; });
    return list.length ? { list: list, suffix: el.getAttribute('data-suffix') || '+ Labor' } : null;
  }
  function laborVariantFor(map, term, tierLabel) {
    for (var i = 0; i < map.list.length; i++) {
      var v = map.list[i];
      if (v.term === term && v.tier === tierLabel && v.available) return v;
    }
    return null;
  }
  function fmtUsd(cents) {
    return '$' + (Math.round(cents) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function installCartMerge() {
    if (window.__cvLaborFetch) return;
    window.__cvLaborFetch = true;
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (laborState.on && laborState.variantId > 0 && url.indexOf('/cart/add') !== -1 && init && typeof init.body === 'string') {
          var payload = JSON.parse(init.body);
          if (payload && Array.isArray(payload.items) && payload.items.length) {
            var alreadyThere = payload.items.some(function (it) { return Number(it.id) === laborState.variantId; });
            var productQty = Number(payload.items[0].quantity) || 1;
            var section = document.querySelector('[data-product-section]');
            if (!alreadyThere) {
              payload.items.push({
                id: laborState.variantId,
                quantity: productQty,
                properties: {
                  'Covers': (section && section.dataset.productTitle) || '',
                  '_covered_variant': String(payload.items[0].id || ''),
                  '_coverage_term': laborState.term + '-labor',
                  '_coverage_tier': laborState.tier
                }
              });
              init = Object.assign({}, init, { body: JSON.stringify(payload) });
            }
          }
        }
      } catch (e) { /* pass through untouched */ }
      return origFetch.call(this, input, init);
    };
  }

  function buildPlanPills() {
    var wrap = document.querySelector('[data-protection-options]');
    if (!wrap || wrap.dataset.cvPills) return false;
    var section = wrap.closest('[data-product-section]') || document;
    var radios = [].slice.call(wrap.querySelectorAll('input[type="radio"][data-protection-option]'));
    if (!radios.length) return false;
    var laborMap = readLaborMap(section);
    wrap.dataset.cvPills = '1';
    wrap.classList.add('cv-plan-row');

    if (!laborMap) {
      /* -------- original three-pill path, unchanged -------- */
      var opts = [].slice.call(wrap.querySelectorAll('label'));
      var none = document.createElement('label');
      none.className = 'cv-plan-pill';
      var noneInput = document.createElement('input');
      noneInput.type = 'radio';
      noneInput.name = 'protection_plan';
      noneInput.value = '';
      noneInput.className = 'cv-plan-input';
      noneInput.checked = !wrap.querySelector('input[type="radio"]:checked');
      var noneText = document.createElement('span');
      noneText.className = 'cv-plan-term';
      noneText.textContent = 'No plan';
      none.appendChild(noneInput);
      none.appendChild(noneText);
      wrap.insertBefore(none, wrap.firstChild);

      opts.forEach(function (label) {
        var radio = label.querySelector('input[type="radio"]');
        var price = label.querySelector('[data-protection-price]');
        if (!radio) return;
        var raw = radio.getAttribute('data-protection-term') || radio.value || '';
        var term = raw.replace('-year', '-Year');
        term = term.charAt(0).toUpperCase() + term.slice(1);
        label.className = 'cv-plan-pill';
        label.innerHTML = '';
        radio.className = 'cv-plan-input';
        label.appendChild(radio);
        var t = document.createElement('span');
        t.className = 'cv-plan-term';
        t.textContent = term;
        label.appendChild(t);
        if (price) {
          var pw = document.createElement('span');
          pw.className = 'cv-plan-price';
          pw.appendChild(price);
          label.appendChild(pw);
        }
      });
      var sync = function () {
        [].slice.call(wrap.querySelectorAll('.cv-plan-pill')).forEach(function (l) {
          var i = l.querySelector('input[type="radio"]');
          l.classList.toggle('is-selected', !!(i && i.checked));
        });
      };
      wrap.addEventListener('change', sync);
      sync();
      return true;
    }

    /* -------- four-pill labor path -------- */
    installCartMerge();
    var byTerm = {};
    radios.forEach(function (r) {
      byTerm[r.getAttribute('data-protection-term')] = r;
      var lab = r.closest('label');
      if (lab) lab.style.display = 'none'; else r.style.display = 'none';
    });

    var defs = [
      { term: '2-year', labor: false, label: '2-Year' },
      { term: '2-year', labor: true, label: '2-Year ' + laborMap.suffix },
      { term: '5-year', labor: false, label: '5-Year' },
      { term: '5-year', labor: true, label: '5-Year ' + laborMap.suffix }
    ];
    var pills = [];
    defs.forEach(function (d) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cv-plan-pill cv-plan-pill--btn';
      b.setAttribute('data-cv-plan', d.term + (d.labor ? '-labor' : ''));
      var t = document.createElement('span');
      t.className = 'cv-plan-term';
      t.textContent = d.label;
      var p = document.createElement('span');
      p.className = 'cv-plan-price';
      p.textContent = '—';
      b.appendChild(t);
      b.appendChild(p);
      wrap.appendChild(b);
      pills.push({ el: b, priceEl: p, def: d });
    });

    var optout = document.createElement('button');
    optout.type = 'button';
    optout.className = 'cv-plan-optout is-selected';
    optout.textContent = 'No thanks, skip coverage';
    wrap.parentNode.insertBefore(optout, wrap.nextSibling);

    var selected = null; /* index into pills, or null = opt out */

    function currentTier(term) {
      var r = byTerm[term];
      return (r && r.dataset.protectionTier) || '';
    }
    function protPrice(term) {
      var r = byTerm[term];
      return Number(r && r.dataset.protectionPrice) || 0;
    }
    function refreshPrices() {
      pills.forEach(function (pl) {
        var tier = currentTier(pl.def.term);
        var base = protPrice(pl.def.term);
        if (!pl.def.labor) {
          pl.priceEl.textContent = base ? fmtUsd(base) : '—';
          pl.el.disabled = !base;
          return;
        }
        var lv = tier ? laborVariantFor(laborMap, pl.def.term, tier) : null;
        if (base && lv) {
          pl.priceEl.textContent = fmtUsd(base + lv.price);
          pl.el.disabled = false;
        } else {
          pl.priceEl.textContent = 'Unavailable';
          pl.el.disabled = true;
          if (selected !== null && pills[selected] === pl) applySelection(null);
        }
      });
      if (selected !== null && pills[selected].def.labor) {
        var d = pills[selected].def;
        var lv2 = laborVariantFor(laborMap, d.term, currentTier(d.term));
        laborState.variantId = lv2 ? lv2.id : 0;
        laborState.tier = currentTier(d.term);
      }
    }
    function applySelection(idx) {
      selected = idx;
      var def = idx === null ? null : pills[idx].def;
      Object.keys(byTerm).forEach(function (term) {
        var r = byTerm[term];
        var want = !!(def && def.term === term);
        if (r.checked !== want) {
          r.checked = want;
          r.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      if (def && def.labor) {
        var lv = laborVariantFor(laborMap, def.term, currentTier(def.term));
        laborState.on = true;
        laborState.term = def.term;
        laborState.tier = currentTier(def.term);
        laborState.variantId = lv ? lv.id : 0;
      } else {
        laborState.on = false;
        laborState.variantId = 0;
      }
      pills.forEach(function (pl, k) { pl.el.classList.toggle('is-selected', k === idx); });
      optout.classList.toggle('is-selected', idx === null);
    }
    pills.forEach(function (pl, k) {
      /* Re-clicking the selected pill is a no-op (double-click safe);
         deselection is the opt-out link's job. */
      pl.el.addEventListener('click', function () { if (selected !== k) applySelection(k); });
    });
    optout.addEventListener('click', function () { applySelection(null); });

    if ('MutationObserver' in window) {
      var mo = new MutationObserver(refreshPrices);
      radios.forEach(function (r) {
        mo.observe(r, { attributes: true, attributeFilter: ['data-protection-tier', 'data-protection-price', 'disabled'] });
      });
    }
    refreshPrices();
    applySelection(null);
    setTimeout(refreshPrices, 800);
    return true;
  }

  function watchPlanPills() {
    if (buildPlanPills()) return;
    var tries = 0;
    var timer = setInterval(function () {
      if (buildPlanPills() || ++tries > 20) clearInterval(timer);
    }, 300);
  }

  function init() {
    root = document.querySelector('[data-cv-chipnav]');
    if (!root || root.dataset.cvExtras) return;
    root.dataset.cvExtras = '1';

    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          tracked.forEach(function (t) {
            t.chip.classList.toggle('is-active', t.target === entry.target);
          });
        });
      }, { rootMargin: '-96px 0px -70% 0px', threshold: 0 });
    }

    root.querySelectorAll('[data-cv-chip]').forEach(function (chip) {
      var el = document.getElementById(chip.getAttribute('href').slice(1));
      if (el) observe(chip, el);
    });

    [
      { id: 'cvsec-included', label: "What's included" },
      { sel: '[id$="__purchase_support"]', label: 'Complete your system' },
      { sel: '[id$="__reviews"]', label: 'Reviews' },
      { sel: '[id$="__install_videos"]', label: 'Install video' }
    ].forEach(function (item) {
      var el = item.id ? document.getElementById(item.id) : document.querySelector(item.sel);
      if (!el || !el.offsetParent || !el.offsetHeight) return;
      if (!el.id) el.id = 'cvsec-extra-' + tracked.length;
      addChip(el.id, item.label, null);
    });

    root.addEventListener('click', function (e) {
      var chip = e.target.closest('a[href^="#"]');
      if (!chip || !root.contains(chip)) return;
      var el = document.getElementById(chip.getAttribute('href').slice(1));
      if (!el) return;
      e.preventDefault();
      e.stopPropagation();
      if (el.tagName === 'DETAILS') el.open = true;
      scrollToEl(el);
    }, true);

    watchDescription();
    watchRating();
    watchPlanPills();

    if (root.querySelectorAll('a').length < 2) root.style.display = 'none';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
